import { useDispatch } from 'react-redux';
import useToast from 'components/hooks/useToast';
import { handleMergeAccounts } from 'components/ContributorManagementMenu/ContributorManagementMenu';

const useHandleSubmitMerge = () => {
  const dispatch = useDispatch();
  const toast = useToast();

  const handleSubmitMerge = async (primaryId, childIds) => {
    const connectedContributors = childIds.map(id => ({
      id,
      parent_id: primaryId
    }));
    const opName = 'Merge account'; // VIEWS_TO_TEXT[VIEWS.merge],
    handleMergeAccounts({ connectedContributors, opName, dispatch, toast });
  };

  return { handleSubmitMerge };
};

export default useHandleSubmitMerge;
